import type { CustomBreadcrumbsProps } from '@/components/CustomBreadcrumbs';
import RedirectOnLogout from '@/components/RedirectOnLogout';
import NavProvider from '@/provider/NavProvider';
import React from 'react';
import MainLayoutInternal from './MainLayoutInternal';
import useCustomLayoutMode from '@/hooks/useCustomLayoutMode';
import MainLayoutInternalSide from './MainLayoutInternalSide';

type Props = {
  title?: React.ReactNode;
  children?: React.ReactElement;
  breadcrumbProps?: CustomBreadcrumbsProps;
  contentPaddingBottom?: number;
  noTopMargin?: boolean;
};

export default function MainLayout(props: Props) {
  const [layoutMode] = useCustomLayoutMode();
  return (
    <RedirectOnLogout>
      <NavProvider>
        {/* {layoutMode === 'topbar' ? (
          <MainLayoutInternal {...props} />
        ) : ( */}
        <MainLayoutInternalSide {...props} />
        {/* )} */}
      </NavProvider>
    </RedirectOnLogout>
  );
}
